import { session } from './cloud-video';
import { videoFetch } from './video-http';

/** Signs in through the loopback-only development fixture without navigating away from a loaded ride. */
export async function signInToLocalPreview(): Promise<void> {
  const response = await videoFetch('/auth/login', { method: 'POST', credentials: 'same-origin' });
  if (!response.ok) throw new Error('The local preview could not sign in. Check the local server.');
  await session();
}
